import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next';
import App from './App.tsx'
import './index.css'
import i18n from './i18n'

// --- VERIFICACIÓN DE DESPLIEGUE ---
const deployTimestamp = new Date().toISOString();
console.log(`%c🚀 INICIANDO FRONT-SOLO-LOGUIN [Versión: ${deployTimestamp}]`, 'color: #3b82f6; font-size: 14px; font-weight: bold;');

try {
    // 2. Matar Service Workers (Solo si es necesario para actualización de assets)
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
            if (registrations.length > 0) {
                console.log(`💀 Se encontraron ${registrations.length} Service Workers. Eliminando para asegurar frescura...`);
                for (let registration of registrations) {
                    registration.unregister();
                }
            }
        });
    }
} catch (e) {
    console.error('Error durante la inicialización:', e);
}
// ---------------------------------------------

console.log(`BUILD_TIME: ${new Date().toISOString()}`);

// Auto-verificación de versión para evitar cachés antiguas
fetch('/version.json?t=' + Date.now())
    .then(r => r.json())
    .then(v => {
        console.log('%c🚀 Versión Desplegada:', 'color: #3b82f6; font-weight: bold; font-size: 12px;', v.date);
        console.log('%cCache Status Check:', 'color: #10b981;', 'Solicitando datos frescos...');
    })
    .catch(() => console.log('No version info available'));

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>
    </React.StrictMode>,
)
